import { CSSProperties } from 'react';

import Icon from '@ui/icons/icon';
import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import styles from './icon-toggle-v2.module.css';

interface IconToggleV2Props {
  leftIconName: string;
  leftValue: string | number;
  rightIconName: string;
  rightValue: string | number;
  onToggle: () => void;
  selected: string | number;
  ariaLabel: string;
  backgroundColor?: string;
  activeColor?: string;
  iconActiveColor?: string;
  iconInactiveColor?: string;
  dataComponent?: string;
}

export default function IconToggleV2({
  leftIconName,
  leftValue,
  rightIconName,
  rightValue,
  onToggle,
  selected,
  ariaLabel,
  backgroundColor = 'var(--local-switch-bg)',
  activeColor = 'var(--local-switch-active)',
  iconActiveColor = 'var(--global-ico-text-1)',
  iconInactiveColor = 'var(--global-ico-text-3)',
  dataComponent = 'IconToggleV2',
}: IconToggleV2Props) {
  const leftSelected = leftValue === selected;
  const rightSelected = rightValue === selected;

  const getIconColor = (active: boolean) => (active ? iconActiveColor : iconInactiveColor);

  return (
    <Button
      clear
      borderRadius="100px"
      onClick={onToggle}
      backgroundColor={backgroundColor}
      hoverOpacity={0.8}
      designSize="small"
      padding="2px"
      type="button"
      aria-label={ariaLabel}
      data-component={dataComponent}
    >
      <div className={styles.track} style={{ '--icon-toggle-active-color': activeColor } as CSSProperties}>
        <div
          className={styles.pill}
          style={{
            transform: rightSelected ? 'translateX(calc(var(--icon-size) + var(--track-gap)))' : 'translateX(0)',
          }}
        />
        <Container className={`square-28 radius-full flex-column ai-center jc-center ${styles.icon}`}>
          <Icon name={leftIconName} size={12} color={getIconColor(leftSelected)} />
        </Container>
        <Container className={`square-28 radius-full flex-column ai-center jc-center ${styles.icon}`}>
          <Icon name={rightIconName} size={12} color={getIconColor(rightSelected)} />
        </Container>
      </div>
    </Button>
  );
}
